import { render, staticRenderFns } from "./ElementTransformProperties.vue?vue&type=template&id=18dfc5b6&scoped=true"
import script from "./ElementTransformProperties.vue?vue&type=script&setup=true&lang=ts"
export * from "./ElementTransformProperties.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ElementTransformProperties.vue?vue&type=style&index=0&id=18dfc5b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dfc5b6",
  null
  
)

export default component.exports